import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/authStore'

/**
 * TF (TakeFav Organizational System) Routes
 * All routes for saving, organizing, and sharing favorites
 */
export const createTFRoutes = (): RouteRecordRaw[] => [
  {
    path: '/tf',
    name: 'tf-home',
    component: () => import('../views/tf/TFHome.vue'),
    meta: {
      title: 'My Favorites',
      requiresAuth: true,
    },
  },
  {
    path: '/tf/public',
    name: 'tf-public',
    component: () => import('../views/tf/TFPublic.vue'),
    meta: {
      title: 'My Public Shares',
      requiresAuth: true,
    },
  },
  {
    path: '/tf/feed',
    name: 'tf-feed',
    component: () => import('../views/tf/TFFeed.vue'),
    meta: {
      title: 'Social Feed',
      requiresAuth: true,
    },
  },
  {
    path: '/tf/settings',
    name: 'tf-settings',
    component: () => import('../views/tf/TFSettings.vue'),
    meta: {
      title: 'TF Settings',
      requiresAuth: true,
    },
  },
]

/**
 * TF Route Guard
 * Checks authentication for protected TF routes
 */
export const tfGuard = (to: any, from: any, next: any) => {
  // Check if route requires auth
  if (to.meta?.requiresAuth) {
    const authStore = useAuthStore()
    
    // Check if user is authenticated
    if (!authStore.isAuthenticated) {
      next({ name: 'sign-in', query: { redirect: to.fullPath } })
      return
    }
  }
  next()
}



